import PropTypes from 'prop-types'
import React from 'react'
import clsx from 'clsx'
import { FilterSelectorContext, useFilterSelectorValues } from './context'
import { FilterToggle } from './FilterToggle'

export const FilterGroup = ({
  options,
  applyTo,
  children,
  defaultSelected,
  styles,
  className,
  maxShow = 2,
  iconProps,
  selectedText = 'Selected: ',
  moreText = 'items selected',
  noFilterText,
  resetButton,
  filterTypeSelectProps,
  toggleButtonProps = { size: 'sm' },
  persistKey
}) => {
  const contextValue = useFilterSelectorValues({
    options,
    applyTo,
    defaultSelected,
    maxShow,
    selectedText,
    moreText,
    persistKey
  })

  return (
    <div className={clsx('flex gap-2 flex-wrap', className)} style={{ styles }}>
      <FilterSelectorContext.Provider value={contextValue}>
        <FilterToggle
          resetButton={resetButton}
          filterTypeSelectProps={filterTypeSelectProps}
          noFilterText={noFilterText}
          iconProps={iconProps}
          {...toggleButtonProps}
        >
          {children}
        </FilterToggle>
      </FilterSelectorContext.Provider>
    </div>
  )
}

FilterGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  applyTo: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  defaultSelected: PropTypes.string,
  styles: PropTypes.object,
  className: PropTypes.string,
  maxShow: PropTypes.number,
  selectedText: PropTypes.string,
  moreText: PropTypes.string,
  iconProps: PropTypes.object,
  noFilterText: PropTypes.string,
  resetButton: PropTypes.shape({
    enable: PropTypes.bool,
    text: 'Reset'
  }),
  filterTypeSelectProps: PropTypes.object,
  toggleButtonProps: PropTypes.object,
  persistKey: PropTypes.string
}
